module.exports = __webpack_public_path__ + "static/media/quotation.23cd606b.svg";